import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import projectsData from './data/projectsData';

// Expose portfolio data globally to serve as the single source of truth for the static Ubuntu Desktop layout
window.portfolioData = projectsData;


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <App />
  </React.Fragment>
);
